document.addEventListener('DOMContentLoaded', function() {
  // ─────────────────────────────────────────────
  // 要素取得
  // ─────────────────────────────────────────────
  const menuToggle      = document.querySelector('.shoppy-menu-toggle');
  const sidebar         = document.querySelector('.shoppy-sidebar');
  const overlay         = document.querySelector('.shoppy-overlay');
  const popupOverlay    = document.querySelector('.shoppy-popup-overlay');
  const headingPopup    = document.querySelector('.shoppy-heading-popup');
  const closePopupBtn   = document.querySelector('.shoppy-close-popup');
  const sidebarLinks    = document.querySelectorAll('.shoppy-sidebar__link');
  const currentHeadingBox = document.querySelector('.shoppy-current-heading');
  const currentHeadingText = currentHeadingBox
    ? currentHeadingBox.querySelector('h3')
    : null;
  let currentSectionId  = '';

  if (!menuToggle || !sidebar || !overlay || !popupOverlay ||
      !headingPopup || !closePopupBtn || !currentHeadingBox) {
    // 必要な要素がないなら何もしない
    return;
  }

  // ─── 1) メニュー開閉 ─────────────────────────
  menuToggle.addEventListener('click', () => {
    sidebar.classList.toggle('open');
    overlay.classList.toggle('open');
  });
  overlay.addEventListener('click', () => {
    sidebar.classList.remove('open');
    overlay.classList.remove('open');
  });

  // ─── 2) ポップアップ開閉 ───────────────────────
  function closePopup() {
    headingPopup.style.display = 'none';
    popupOverlay.style.display = 'none';
  }
  popupOverlay.addEventListener('click', closePopup);
  closePopupBtn.addEventListener('click', closePopup);

  currentHeadingBox.addEventListener('click', () => {
    if (headingPopup.style.display === 'block') {
      closePopup();
    } else {
      updatePopupHighlight();
      headingPopup.style.display = 'block';
      popupOverlay.style.display = 'block';
    }
  });

  // ─── 3) サイドバーリンク処理 ────────────────────
  sidebarLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const href = this.getAttribute('href') || '';
      if (href.startsWith('#')) {
        // 同一ページ内アンカーなら prevent + スムーススクロール
        e.preventDefault();
        sidebarLinks.forEach(l => l.classList.remove('active'));
        this.classList.add('active');
        if (window.innerWidth <= 768) {
          sidebar.classList.remove('open');
          overlay.classList.remove('open');
        }
        const targetId      = href.slice(1);
        const targetEl      = document.getElementById(targetId);
        if (targetEl) {
          const top = targetEl.getBoundingClientRect().top + window.scrollY - 60;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }
      // それ以外の href は何もしない → デフォルトで遷移
    });
  });

  // ─── 4) スクロール監視で現在の見出し更新 ─────────
  function onScroll() {
    const scrollY  = window.scrollY;
    const sections = document.querySelectorAll('.shoppy-content-section');
    let found = null;
    sections.forEach(sec => {
      const top    = sec.getBoundingClientRect().top + window.scrollY;
      const bottom = top + sec.offsetHeight;
      if (scrollY >= top - 60 && scrollY < bottom) found = sec;
    });
    if (found && found.id !== currentSectionId) {
      currentSectionId = found.id;
      const h = found.querySelector('h2, h3');
      if (h && currentHeadingText) {
        currentHeadingText.textContent = `現在の見出し: ${h.textContent}`;
      }
      if (headingPopup.style.display === 'block') updatePopupHighlight();
    }
  }
  window.addEventListener('scroll', onScroll);

  // ─── 5) ポップアップ内リンクでスクロール＆閉じる ────
  const popupItems = headingPopup.querySelectorAll('li[data-target]');
  popupItems.forEach(item => {
    item.addEventListener('click', () => {
      const sel = item.getAttribute('data-target');
      const el  = document.querySelector(sel);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 60;
        window.scrollTo({ top, behavior: 'smooth' });
      }
      closePopup();
    });
  });

  // ─── 6) ポップアップ現在地ハイライト関数 ───────────
  function updatePopupHighlight() {
    popupItems.forEach(li => li.classList.remove('current-item'));
    if (!currentSectionId) return;
    const cur = headingPopup.querySelector(`li[data-section-id="${currentSectionId}"]`);
    if (cur) cur.classList.add('current-item');
  }

  // ─── 7) 初期化(load時) ───────────────────────────
  window.addEventListener('load', () => {
    const first = document.querySelector('.shoppy-content-section');
    if (first) {
      currentSectionId = first.id;
      const h = first.querySelector('h2, h3');
      if (h && currentHeadingText) {
        currentHeadingText.textContent = `現在の見出し: ${h.textContent}`;
      }
    }
    onScroll();
  });
});
